import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

interface CustomProps {
    type: string;
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    placeholder?: string;
}

/**
 * Formats the input by:
 * 1. Removing all non-digit characters.
 * 2. Ensuring the result starts with "38".
 * 3. If already starting with "38", ensuring the following digit is "0".
 *
 * @param {string} value - The input string to format.
 * @returns {string} - The formatted string.
 */
function formatPhoneNumber(value: string): string {
  // Remove all non-digit characters.
  const numericValue = value.replace(/\D/g, "");

  // If the numeric value already starts with "38", handle accordingly.
  if (numericValue.startsWith("38")) {
    const rest = numericValue.slice(2);
    // If there's a remaining part and it doesn't start with "0",
    // prepend a "0" after "38".
    if (rest && rest[0] !== "0") {
      return `38${"0" + rest}`;
    }
    // Otherwise, return the value as is.
    return `38${rest}`;
  }

  // If it doesn't start with "38", simply prepend it.
  return `38${numericValue}`;
}

const MaskedField = forwardRef<HTMLInputElement, CustomProps>((props, ref) => {
    const { onChange, type, placeholder, ...other } = props;
    return (
        <IMaskInput
            onAccept={(value: string) => {
                if (type === "PhoneInput" && value) {
                    const finalValue = formatPhoneNumber(value)
                    onChange({ target: { name: props.name, value: finalValue } });
                    return
                }
                onChange({ target: { name: props.name, value } })
            }}
            {...other}
            inputRef={ref}
            overwrite={"shift"}
            unmask={false}
            placeholder={type === "PhoneInput" ? "+38 (___) ___-__-__" : placeholder}
        />
    );
});

MaskedField.displayName = "TextMaskCustom";
export { MaskedField };
